import React, { Component } from 'react';
import {
  Clear as ClearIcon,
  InsertInvitation as CalendarIcon
} from "@material-ui/icons";
import { IconButton, InputAdornment } from "@material-ui/core";
import MomentUtils from "@date-io/moment";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import moment from 'moment';
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
////import moment from 'moment';
import "moment/locale/pt-br";

const styles = theme => ({

  floatingLabelFocusStyle: {
    flexGrow: 1,
    height: 0,
    position: 'relative',
    marginTop: 0
  },

  asterisk: {
    color: '#f44336',
    fontWeight: 'bold',
  },

  root: {
    backgroundColor: '#f9f9f9'
  }
})

class DatePickers extends Component {
  state = {
    selectedDate: null,
    locale: "pt-br",
  };

  handleDateChange = (date) => {
    var name = this.props.name;
    var composicaoIntervalo = this.props.composicaoIntervalo;

    if (composicaoIntervalo !== undefined && composicaoIntervalo !== null
      && composicaoIntervalo.valorComparacao !== null
      && composicaoIntervalo.valorComparacao !== undefined) {
      this.props.onChange(name, date, true, composicaoIntervalo.tipo, composicaoIntervalo.valorComparacao);
    }
    else {
      this.props.onChange(name, date);
    }

    this.setState({ selectedDate: date });
  };

  handleonDateClear = e => {
    e.stopPropagation();
    var name = this.props.name;
    this.setState({ selectedDate: null });
    this.props.onChange(name, null);
  };

  handleAbort = e => {
    if (this.state.selectedDate === null) {
      var name = this.props.name;
      this.props.onChange(name, null);
      this.setState({ selectedDate: null });
    }
  }

  render() {
    const { selectedDate } = this.state;
    const { locale } = this.state;
    const { classes } = this.props;

    var validarErro = false;
    var mensagemErro = ""

    if (this.props.validador && this.props.validador.length > 0) {
      var inconsistencia = this.props.validador.filter(x => x.propriedadeValidada === this.props.name && x.erro);
      validarErro = inconsistencia.length > 0;
      mensagemErro = inconsistencia.length > 0 ? inconsistencia[0].mensagemErro : "";
    }

    return (
      <MuiPickersUtilsProvider utils={MomentUtils} locale={locale}>
        <KeyboardDatePicker
          disableToolbar
          variant="inline"
          inputVariant="filled"
          fullWidth
          required={this.props.requerido}
          error={validarErro ? true : false}
          className={classes.root}
          autoComplete="off"
          margin="normal"
          size="small"
          value={(function () {
            let v = (typeof this.props.valor !== 'undefined' ? this.props.valor : undefined);
            if (v === '') v = null;
            if (typeof v === 'string') {
              const m = moment(v, 'DD/MM/YYYY', true);
              v = m.isValid() ? m : null;
            }
            if (v === undefined || v === null) {
              v = selectedDate !== null ? selectedDate : (typeof this.props.valorPadrao !== 'undefined' ? this.props.valorPadrao : null);
            }
            return v;
          }).call(this)}
          label={this.props.labelDatePicker}
          format="DD/MM/YYYY"
          onChange={this.handleDateChange}
          onClose={this.handleAbort}
          helperText={validarErro ? mensagemErro : this.props.textoAjuda}
          disabled={this.props.desabilitado === true || this.props.desabilitado === 'true'}
          disablePast={this.props.disablePast}
          disableFuture={this.props.disableFuture}
          style={{ backgroundColor: '#00000000' }}
          InputLabelProps={{
            className: classes.floatingLabelFocusStyle,
            classes: { asterisk: classes.asterisk },
            shrink: true,
          }}
          InputProps={{
            disableUnderline: true,
            endAdornment: selectedDate !== null ? (
              <InputAdornment position="end">
                <IconButton onClick={this.handleonDateClear}>
                  <ClearIcon />
                </IconButton>
              </InputAdornment>
            ) : (
              <InputAdornment position="end">
                <IconButton>
                  <CalendarIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
          animateYearScrolling={false}
        />
      </MuiPickersUtilsProvider>
    );
  }
}

DatePickers.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DatePickers);
